<ng-template #loading>
   <ng-container *ngIf="error.none">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
   </ng-container>
</ng-template>

<ng-template #spinner>
   <mat-spinner diameter="30"></mat-spinner>
   <br/>
</ng-template>

<div *ngIf="loaded else loading" class="common-m1em">
   <div class="buttons" *ngIf="!saving else spinner">
      <button id="saveTemplateButton" mat-raised-button [disabled]="!template.name" color="primary" (click)="save()">
         <mat-icon>save</mat-icon> SAVE
      </button>

      <button id="createShipmentButton" mat-raised-button color="accent" *ngIf="template.id && hasShip" (click)="createShipment( template.id )" >
         <mat-icon svgIcon="createshipment"></mat-icon> CREATE SHIPMENT
      </button>
      
      <button id="createQuotationButton" mat-raised-button color="accent" *ngIf="template.id && hasQuote" (click)="createQuotation( template.id )" >
         <mat-icon>request_quote</mat-icon> CREATE QUOTE
      </button>

      <button id="deleteTemplateButton" mat-raised-button color="warn" class="delete" *ngIf="template.id" (click)="delete( template.id )">
         <mat-icon>delete</mat-icon> DELETE
      </button>
   </div>

   <div class="template-details">
      <mat-form-field>
         <input id="templateNameInput" matInput placeholder="Template Name" name="name" [(ngModel)]="template.name" required [disabled]="saving" />
      </mat-form-field>

      <mat-form-field #templatedesc class="template-desc">
         <textarea id="templateDescriptionInput" matInput #tempdesc rows="5" [maxlength]="255" placeholder="Template Description" name="name" [(ngModel)]="template.description" [disabled]="saving"></textarea>
         <mat-hint align="end" *ngIf="tempdesc?.value.length as l">{{l || 0}} / 255</mat-hint>
      </mat-form-field>

      <mat-radio-group id="templateRadioGroup" [(ngModel)]="template.shared" [disabled]="saving">
         Share this template?
         <mat-radio-button id="templateRadioNo" [value]="false">No</mat-radio-button>
         <mat-radio-button id="templateRadioYes" [value]="true">Yes</mat-radio-button>
      </mat-radio-group>
   </div>

   <div>
      <app-shipment [template]="true"></app-shipment>
   </div>
</div>
